export class Vendor {
    label: string;
    value: string;

    id: number;
    companyName: string;
    email: string;
    salutation: string;
    firstName: string;
    middleInitial: string;
    lastName: string;
    jobTitle: string;
    mainEmail: string;
    mainFax: string;
    mainPhone: string;

}